import { Link } from "react-router-dom";
import { Avatar, Menu } from "@mantine/core";
import { IconLayoutDashboard, IconLogout2, IconSettings, IconUser } from "@tabler/icons-react";
import { useAuth } from "../contexts/AuthContext.js";

export function CurrentUser() {
  const { user, logout } = useAuth();

  if (!user) return null;

  const initials = user.displayName
    .split(" ")
    .map((w) => w[0] ?? "")
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <Menu
      position="bottom-end"
      withArrow
      styles={{ item: { fontSize: "0.9rem", padding: "0.5rem 0.75rem" } }}
    >
      <Menu.Target>
        <Avatar
          src={user.avatarUrl}
          alt={user.displayName}
          radius="xl"
          size={42}
          style={{ cursor: "pointer" }}
        >
          {initials}
        </Avatar>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{user.displayName}</Menu.Label>
        <Menu.Item leftSection={<IconLayoutDashboard size="1.1rem" />} component={Link} to="/">
          Dashboard
        </Menu.Item>
        <Menu.Item leftSection={<IconUser size="1.1rem" />} component={Link} to="/my-profile">
          My Profile
        </Menu.Item>
        <Menu.Item leftSection={<IconSettings size="1.1rem" />} component={Link} to="/settings">
          Settings
        </Menu.Item>

        <Menu.Divider />

        <Menu.Item
          color="red"
          leftSection={<IconLogout2 size="1.1rem" />}
          onClick={() => void logout()}
        >
          Sign out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
